export const TRANS = {
  newTab: { en: ' (opens in a new tab)', fi: ' (avautuu uuteen välilehteen)' },
};
